"use client";
import ReactDOM from "react-dom";
export const defaultContainer = typeof document === "undefined" ? null : document.body;
export function Portal({ children, container = defaultContainer }) {
    return container ? ReactDOM.createPortal(children, container) : null;
}
export default Portal;
//# sourceMappingURL=portal.js.map